module.exports = __webpack_public_path__ + "static/img/login-user.15a8854.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login-user.png
// module id = kflo
// module chunks = 4